import { useDime } from '@office-start/dime-service';
import { DimeExperience } from '@office-start/dime-types';
import { useCallback, useMemo } from 'react';
import { useDimeTargetUrl } from './useDimeTargetUrl';
export var useDimeCallback = function (_a) {
    var baseUrl = _a.baseUrl, area = _a.area, _b = _a.disableSubscriptionCheck, disableSubscriptionCheck = _b === void 0 ? false : _b;
    var targetUrl = useDimeTargetUrl(baseUrl, area);
    var showDime = useDime({
        disableSubscriptionCheck: disableSubscriptionCheck,
        experiences: [DimeExperience.WelcomeBadge],
    });
    var showDimeCallback = useCallback(function () {
        if (showDime) {
            showDime(DimeExperience.WelcomeBadge, targetUrl);
        }
    }, [showDime, targetUrl]);
    return useMemo(function () {
        if (showDime) {
            return showDimeCallback;
        }
        return undefined;
    }, [showDime, showDimeCallback]);
};
//# sourceMappingURL=useDimeCallback.js.map